import { NAV_ROUTES } from "components/NavigationBar";
import { CARRIER_PROFILE_SOURCE_QUERY_PARAM } from "constants/index";
import { appendQueryParamToUrl } from "utils";

import type { CarrierProfileSource } from "constants/index";

/*
the route param is arbitrary user input, so require the whole value to be a
whole number: parseInt would otherwise read "12invalid" as company 12.
*/
export function parseCompanyIdOrNull(
  rawCompanyId: string | undefined,
): number | null {
  if (!rawCompanyId || !/^\d+$/.test(rawCompanyId)) {
    return null;
  }

  const companyId = Number(rawCompanyId);

  return Number.isSafeInteger(companyId) ? companyId : null;
}

/*
The other half of `parseProfileSource`: every in-app link to a carrier profile
builds its URL here so the surface the viewer came from is tagged on the way in.
A profile reached without this tag reports as DIRECT.
*/
export function buildCarrierProfileUrl(
  companyId: number,
  source: CarrierProfileSource,
): string {
  return appendQueryParamToUrl(
    NAV_ROUTES.companyProfile(companyId),
    CARRIER_PROFILE_SOURCE_QUERY_PARAM,
    source,
  );
}
